// TFI Processor constants
export const TFI_PROCESSOR_ID = '9de2e485-96ae-4dc2-a930-4f986f24864d';
export const TFI_PROCESSOR_NAME = 'TFI';
export const TFI_ASYNC_MODE_CODE = 'tfiAsyncMode';

// Processor types
export const PROCESSOR_TYPES = {
  AEROPAY: 'Aeropay',
  BARTERPAY: 'Barterpay',
  MOCK: 'MOCK',
} as const;

// Configuration codes
export const CONFIG_CODES = {
  BYPASS_WEBHOOK_CALLBACK: 'bypassWebhookCallback',
  WEBHOOK_BYPASS_STATUS: 'webhookBypassStatus',
} as const;

// Fallback status options for webhooks
export const DEFAULT_STATUS_OPTIONS = [
  { label: 'Undefined', value: '' },
  { label: 'Started', value: 'started' },
  { label: 'Approved', value: 'approved' },
  { label: 'Error', value: 'error' },
] as const;

// Database consistency delay (TODO: Replace with proper polling)
export const DB_SYNC_DELAY = 500;
